import * as React from 'react';
import { useDispatch } from 'react-redux';

import { ENewReviewModalStep } from '../../types/newReview';
import { RatingsContainer } from '../NewReview/Rating';
import { ReviewContainer } from '../NewReview/Review';
import { DEFAULT_MODERATION_LINK } from '../../constants/reviews/moderation';
import { useApplicationContext } from '../../utils/applicationContext';
import { Success } from '../../components/FormCommon/Success';
import { Error } from '../../components/FormCommon/Error';
import { addReviewActions } from '../../actions/newReview/addReviewActions';

export interface INewReviewModalContentContainerProps {
  step: ENewReviewModalStep;
  onClose(): void;
}

export const NewReviewModalContentContainer: React.FC<INewReviewModalContentContainerProps> = props => {
  const dispatch = useDispatch();
  const { config } = useApplicationContext();
  const { step, onClose } = props;
  const moderationUrl = config.get<string>('newbuilding-reviews-frontend.moderationUrl') || DEFAULT_MODERATION_LINK;

  const retry = React.useCallback(() => {
    dispatch(addReviewActions());
  }, [dispatch]);

  switch (step) {
    case ENewReviewModalStep.Rating: {
      return <RatingsContainer />;
    }
    case ENewReviewModalStep.Review: {
      return <ReviewContainer />;
    }
    case ENewReviewModalStep.Success: {
      return <Success type="отзыв" url={moderationUrl} close={onClose} />;
    }
    case ENewReviewModalStep.Error: {
      return <Error retry={retry} type="Отзыв" />;
    }
  }
};
